module.exports = __webpack_public_path__ + "static/hero-bf5ae6b52650491338dbd8d66868d841.jpg";